import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthConfig, AUTH_CONFIG } from '../auth.config';
import { TokenResponse } from '../models';
import { BasicInformation } from '@core/modules/user/models';

@Injectable({
  providedIn: 'any'
})
export class AuthRemote {
  constructor(private http: HttpClient, @Inject(AUTH_CONFIG) private config: AuthConfig) {}

  updateTokenLanguage(data: Partial<BasicInformation>): Observable<string> {
    return this.http
      .post<TokenResponse>(this.config.REMOTE.UPDATE_TOKEN_LANGUAGE, { data })
      .pipe(map((tokenResponse) => tokenResponse.token));
  }

  resendActivationLink(email: string): Observable<any> {
    return this.http.put<any>(this.config.REMOTE.UPDATE_ACTIVATION_TOKEN, { email });
  }
}
